// Local dev ports, overridable via `npm run dev -- --tf-port=<n> --op-port=<n>` (see
// scripts/dev.ts), which forwards them to the browser bundle as NEXT_PUBLIC_TF_PORT /
// NEXT_PUBLIC_OP_PORT. Both apps' bundles need both values regardless of which app they're
// running in - getEnvByHostname and getPortalUrl use them to recognize the local dev servers
// by port and to build the cross-app switch link.
//
// `process` is guarded because Cypress component tests bundle these modules with plain
// webpack, which has no process shim - a bare `process.env` here throws
// "process is not defined" at import time and fails every component spec that reaches
// this file. Same idiom as config/env.ts.
export const TF_DEV_PORT = (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_TF_PORT) || '8081';
export const OP_DEV_PORT = (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_OP_PORT) || '8085';

/**
 * Returns the canonical decimal form of a port, or null if it is not a plain 1-65535 integer.
 *
 * Shared by scripts/dev.ts and the cypress e2e configs, which both interpolate a port from
 * TF_PORT/OP_PORT into something that parses it loosely. In a URL the damage is not obvious:
 * `http://localhost:${'8085@attacker.example'}` is a valid URL whose host is
 * `attacker.example`, so an unvalidated value silently redirects the whole suite. In a shell
 * command string it is a command injection. Callers decide how to fail; this only decides
 * what is valid.
 */
export const normalizeDevPort = (value: string): string | null => {
  const port = Number(value);
  const valid = /^\d+$/.test(value.trim()) && Number.isInteger(port) && port >= 1 && port <= 65535;
  return valid ? String(port) : null;
};
